// @flow

import { Grid } from 'semantic-ui-react';
import React from 'react';
import useIsAdmin from '@streaming-projects/useIsAdmin';
import { useFormikContext } from 'formik';
import { If } from '@presentational/If';
import { DISCOUNT_EXCEEDING_25_PERCENT_MESSAGE } from '@streaming-projects/constants';
import { StyledMessage } from '@src/common-utils/styledComponents';

import { Spacer } from '../../../../../presentational/spacing/Spacer';
import { checkIfGlobalDiscountExceedsThresholdForNonAdminWhenTouched } from '../utils';

import { SPGlobalDiscountNoteContainer } from './SPGlobalDiscountNoteContainer';
import { SPGlobalDiscountsUpdateButtonContainer } from './SPGlobalDiscountsUpdateButtonContainer';
import { SPGlobalDiscountLabelContainer } from './SPGlobalDiscountLabelContainer';
import { SPGlobalDiscountsTextFieldContainer } from './SPGlobalDiscountsTextFieldContainer';

export const SPGlobalDiscountContainer = ({ readOnlyMode }) => {
  const isAdminUser = useIsAdmin();
  const formik = useFormikContext();

  const doesDiscountExceedMaxThreshold =
    checkIfGlobalDiscountExceedsThresholdForNonAdminWhenTouched({
      isAdminUser,
      formik,
    });

  const errorMessage = doesDiscountExceedMaxThreshold
    ? DISCOUNT_EXCEEDING_25_PERCENT_MESSAGE
    : null;

  return (
    <Grid columns={4} stackable={true}>
      <Spacer y={12} />
      {/* { todo::SP restructure styling for label} */}
      <Grid.Column style={{ marginLeft: '-8px' }} textAlign="middle" width={2}>
        <SPGlobalDiscountLabelContainer />
      </Grid.Column>
      <Grid.Column textAlign="middle" width={2}>
        <SPGlobalDiscountsTextFieldContainer readOnlyMode={readOnlyMode} />
      </Grid.Column>
      <If test={doesDiscountExceedMaxThreshold}>
        <StyledMessage color="red" content={errorMessage} />
      </If>
      <Grid.Column textAlign="middle" width={1}>
        <SPGlobalDiscountsUpdateButtonContainer
          disabled={doesDiscountExceedMaxThreshold}
          readOnlyMode={readOnlyMode}
        />
      </Grid.Column>
      <Grid.Column textAlign="middle" width={5}>
        <SPGlobalDiscountNoteContainer />
      </Grid.Column>
    </Grid>
  );
};
